export default "__VITE_ASSET__9844456c__"